export default "__VITE_ASSET__BuEYCzHE__"